import CategoryCard from "components/general/Card/CategoryCard";
import CategoryCardList from "components/general/CategoryCardList";
import Container from "components/general/Container";
import PageHeader from "components/general/Headers/PageHeader";
import PageLoader from "components/general/PageLoader";
import ScrollContainer from "components/general/ScrollContainer";
import Section from "components/general/Section";
import Seo from "components/general/Seo";
import { Box, FlatList, SafeAreaView, View } from "components/ui";
import { Typography } from "components/ui/Typography";
import { useGlobalSearchParams } from "expo-router";
import React from "react";
import { ActivityIndicator, Platform } from "react-native";
import { useGetCategoryBySlugQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
export default function Page() {
	const isMobile = useIsMobile();
	const { category: slug } = useGlobalSearchParams();

	const {
		data: category,
		isLoading,
		isFetching,
		isError,
		error,
		currentData,
	} = useGetCategoryBySlugQuery(
		{
			slug: String(slug),
		},
		{
			skip: !slug,
		},
	);
	const topProducts = [
		{
			image: "",
			name: "Tork Xpress Flushable Multifold Hand Towel - White",
			unitPrice: 1735,
			oldUnitPrice: 2700,
			stockcode: "123123123",
			status: "inStock",
		},
		{
			image: "",
			name: "Tork Ultraslim Towel Dispenser H4 - ABS Plastic",
			unitPrice: 133,
			oldUnitPrice: 190,
			stockcode: "123123123",
			status: "backOrder",
		},
		{
			image: "",
			name: "Puregiene Sovereign Luxury Ultraslim I/L Towel (Carton 2400)",
			unitPrice: 1553,
			oldUnitPrice: 3500,
			stockcode: "11122233",
			status: "none",
		},
	];
	if (isLoading) {
		return <PageLoader />;
	}
	if (isMobile && Platform.OS !== "web") {
		return (
			<SafeAreaView>
				<FlatList
					ListHeaderComponent={() => (
						<View bg="$basicwhite">
							<PageHeader title={category?.name} />
							<Box p={16} backgroundColor={"$neutral25"}>
								<Typography.H2>Browse {category?.name?.toLowerCase()}</Typography.H2>
							</Box>
						</View>
					)}
					keyExtractor={(item: any) => item.slug}
					// data={[]}
					data={category?.subCategoryCollection ?? []}
					numColumns={2}
					key="_1"
					ListEmptyComponent={() => (
						<Box minHeight={300} marginTop={50}>
							<ActivityIndicator size={"large"} color={"#1A428A"} style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }] }} />
						</Box>
					)}
					columnWrapperStyle={{ justifyContent: "space-between", backgroundColor: "#FAFAFA" }}
					renderItem={({ item }: any) => (
						<Box flex={1 / 2}>
							<CategoryCard category={item} />
						</Box>
					)}
				/>
			</SafeAreaView>
		);
	}
	return (
		<ScrollContainer>
			<Container>
				<Seo description={category?.seoDescription} title={category?.seoTitle} />
				<PageHeader title={category?.name} description={category?.description} />
				<Section gap={24}>
					<Typography.H2>Browse {category?.name?.toLowerCase()}</Typography.H2>
					<CategoryCardList list={category?.subCategoryCollection} />
				</Section>
			</Container>
		</ScrollContainer>
	);
}
